import React from "react";
import TestStats from "@src/components/Tabs/Content/components/TestStats";

const TestStatsPage = () => {
  return <TestStats />;
};

// DEFINING LAYOUT PROPERTIES FOR THIS PAGE
TestStatsPage.getLayoutProps = () => ({
  blockHeader: true,
});

export default TestStatsPage;
